export class ControllerService {
    currentController;
    setControllerName(name) {
        this.currentController = name;
    }
    getControllerName() {
        return this.currentController;
    }
}
